export const ProductTypeConstant = {
    PRODUCT_TYPE_HOTEL: "hotel",
    PRODUCT_TYPE_TOUR: "tour"
}